<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import {Storage} from '@/utils/common';
export default {
  name: 'App',
  mounted() {
    const token = Storage.get('token');
    if (token) {
      // console.log(this.userInfo)
      this.$store.dispatch('routerV/getMenuList', this.userInfo.id);
    }
  }
};
</script>
